module.exports = __webpack_public_path__ + "img/sport-car3-300x300.e16814b2.jpg";